import * as angular from 'angular';
import { reactShell } from 'angular/utils/config';

class PdfCsvExportButtonsComponentCtrl implements ng.IController {
    csvExportUrl: string;
    pdfExportUrl: string;
    allowPdf: boolean;
    allowCsv: boolean;
    reactShell = reactShell;

    $onInit() {
        if (angular.isUndefined(this.allowCsv)) {
            this.allowCsv = true;
        }

        if (angular.isUndefined(this.allowPdf)) {
            this.allowPdf = true;
        }
    }
}

angular.module('app').component('pkpPdfCsvExportButtons', {
    controller: PdfCsvExportButtonsComponentCtrl,
    template: require('app/reporting-details/pdfCsvExportButtons.component.html'),
    bindings: {
        pdfExportUrl: '<?',
        csvExportUrl: '<?',
        allowPdf: '<?',
        allowCsv: '<?'
    }
});
